// app/javascript/controllers/hover_actions_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["actions"]

    connect() {
        // For accessibility, we also show actions on focus-within
        this.element.addEventListener('focusin', this.show.bind(this))
        this.element.addEventListener('focusout', this.handleFocusOut.bind(this))
    }

    show() {
        if (this.hasActionsTarget) {
            this.actionsTarget.classList.remove('opacity-0', 'invisible')
            this.actionsTarget.classList.add('opacity-100', 'visible')
        }
    }

    hide() {
        if (this.hasActionsTarget) {
            this.actionsTarget.classList.add('opacity-0', 'invisible')
            this.actionsTarget.classList.remove('opacity-100', 'visible')
        }
    }

    handleFocusOut(event) {
        // Only hide if focus moved outside this element
        if (!this.element.contains(event.relatedTarget)) {
            this.hide()
        }
    }
}
